// extracted by mini-css-extract-plugin
export var backdropBlur = "_cs-0";
export var contentCard = "_cs-5";
export var frame = "_cs-2";
export var image = "_cs-4";
export var imagePane = "_cs-3";
export var modal = "_cs-1";